<template>
    <span
        class="backlogGrowthCell"
        :class="getGrowthTrendClass"
    >{{ getGrowthTrendPercent }}%</span>
</template>

<script lang="ts">

export default {
    props: ['params'],
    computed: {
        getGrowthTrendPercent() {
            if (this.params.value) {
                return  (this.params.value > 0 ? ' ↑ ' : ' ↓ ') + Math.round(this.params.value);
            }
            return '';
        },

        getGrowthTrendClass() {
            const value = this.params.value; // Access the entire row's data
            if (value > 0) {
                return 'is-pos';
            }
            return 'is-neg';
        }
    }
};
</script>

<style lang="scss">
// Positive mean (backlog is growing) red. negative (backlog is declining) is good
.backlogGrowthCell.is-pos { color: var(--color-status-negative); }
.backlogGrowthCell.is-neg { color: var(--color-status-positive); }
.backlogGrowthCell.is-zero { color: var(--color-status-neutral); }

</style>